import React from 'react';

interface AlertAcknowledgmentWarningProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  title?: string;
  variant?: 'icon' | 'badge' | 'text';
}

export const AlertAcknowledgmentWarning: React.FC<
  AlertAcknowledgmentWarningProps
> = ({
  size = 'md',
  className = '',
  title = 'Alert Acknowledgment Required',
  variant = 'icon',
}) => {
  const getSizeStyle = () => {
    switch (size) {
      case 'sm':
        return { fontSize: '14px' };
      case 'md':
        return { fontSize: '16px' };
      case 'lg':
        return { fontSize: '20px' };
      default:
        return { fontSize: '16px' };
    }
  };

  const getBaseClasses = () => {
    switch (variant) {
      case 'badge':
        return 'badge bg-warning text-dark';
      case 'text':
        return 'text-warning small fw-medium';
      case 'icon':
      default:
        return 'material-symbols-outlined text-warning';
    }
  };

  const baseClasses = getBaseClasses();
  const combinedClasses = `${baseClasses} ${className}`.trim();

  if (variant === 'badge') {
    return (
      <span className={combinedClasses} title={title}>
        <span
          className="material-symbols-outlined me-1"
          style={{ fontSize: '12px' }}
        >
          warning
        </span>
        Acknowledgment Required
      </span>
    );
  }

  if (variant === 'text') {
    return (
      <span className={combinedClasses} title={title}>
        <span
          className="material-symbols-outlined me-1"
          style={{ fontSize: '14px' }}
        >
          warning
        </span>
        Acknowledgment Required
      </span>
    );
  }

  // Default icon variant
  return (
    <span className={combinedClasses} title={title} style={getSizeStyle()}>
      warning
    </span>
  );
};
